import React, { Component } from 'react'
import { CardBenefits, CardBenefitsMobile } from 'loyal-react'
import MediaQuery from 'react-responsive'
import queryString from 'query-string'
import PropTypes from 'prop-types'

class BaseListing extends Component {
  benefits = []
  pageIndex = 1
  pageSize = 9
  totalItens = 0
  constructor (parentContext) {
    super()
    this.props = parentContext
    let tags = []
    let filter = {
      order: {
        selected: undefined
      },
      profiles: [],
      categories: [],
      partners: []
    }

    this.state = {
      filteredBenefits: [],
      openFilter: false,
      profiles: [],
      categories: [],
      partners: [],
      filter,
      tags
    }
    this.onFilterChange = this.onFilterChange.bind(this)
    this.onOrderChange = this.onOrderChange.bind(this)
    this.removeTags = this.removeTags.bind(this)
    this.removeAllTags = this.removeAllTags.bind(this)
    this.startFilter()
  }

  startFilter () {
    const { filter } = this.state
    let query = queryString.parse(this.props.location.search)
    if (query.profile) {
      filter.profiles = this.setFilterValue(
        filter.profiles,
        query.profile,
        'add',
        'PROFILE'
      )
    }
    if (query.category) {
      filter.categories = this.setFilterValue(
        filter.categories,
        query.category,
        'add',
        'CATEGORY'
      )
    }
    if (query.partner) {
      filter.partners = this.setFilterValue(
        filter.partners,
        query.partner,
        'add',
        'PARTNER'
      )
    }
    this.setState({ filter })
  }

  getCardsBenefits (benefit) {
    return [
      <MediaQuery minDeviceWidth={426}>
        <div className='col-4 mb-2 d-none d-md-block'>
          <CardBenefits
            link={benefit.link}
            name={benefit.name}
            description={benefit.description}
            image={benefit.image}
            title={benefit.title}
            alt={benefit.alt}
            titleImg={benefit.titleImg}
            profile={benefit.profile}>
            {benefit.descriptionHtml}
          </CardBenefits>
        </div>
      </MediaQuery>,
      <MediaQuery maxDeviceWidth={425}>
        <CardBenefitsMobile
          link={benefit.link}
          name={benefit.name}
          description={benefit.description}
          image={benefit.image}
          title={benefit.title}
          alt={benefit.alt}
          titleImg={benefit.titleImg}
          profile={benefit.profile}>
          {benefit.descriptionHtml}
        </CardBenefitsMobile>
      </MediaQuery>
    ]
  }

  onOrderChange ({ type }) {
    let {
      filter
    } = this.state
    this.pageIndex = 1
    filter.order.selected = type
    this.setState({
      filter: filter
    })
    this.filterBenefits()
  }

  onFilterChange = (filterType) => e => {
    let filterValue
    let filterAction = 'update'
    let tagType = e.target ? String(e.target.type) : ''
    this.pageIndex = 1

    switch (tagType) {
      case 'checkbox': {
        filterValue = e.target.value
        filterAction = e.target.checked ? 'add' : 'remove'
        break
      }
      case 'text': {
        filterValue = e.target.value
        break
      }
      default: {
        if (e.target) {
          filterAction = e.target.getAttribute('action')
          filterValue = e.target.getAttribute('value')
        }
        break
      }
    }

    filterAction = filterAction || 'update'
    filterValue = filterValue || e

    let {
      filter
    } = this.state

    switch (filterType) {
      case 'PROFILE': {
        filter.profiles = this.setFilterValue(filter.profiles, filterValue, filterAction, filterType)
        break
      }
      case 'CATEGORY': {
        filter.categories = this.setFilterValue(filter.categories, filterValue, filterAction, filterType)
        break
      }
      case 'PARTNER': {
        filter.partners = this.setFilterValue(filter.partners, filterValue, filterAction, filterType)
        break
      }
    }
    this.setState(
      {
        filter: filter
      },
      () => this.filterBenefits()
    )
    this.queryParameters()
  }

  queryParameters () {
    let { filter } = this.state
    let parameters = {}
    if (filter.profiles.length > 0) parameters['profile'] = filter.profiles[0]
    if (filter.categories.length > 0) parameters['category'] = filter.categories[0]
    if (filter.partners.length > 0) parameters['partner'] = filter.partners[0]
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: queryString.stringify(parameters)
    })
  }

  checkExist = (arr, value) => {
    return arr.length > 0 ? arr.indexOf(value) > -1 : true
  }

  filterBenefits = () => {
    let {
      filter
    } = this.state
    let currentBenefits = this.benefits.filter(x => {
      return (
        this.checkExist(filter.profiles, x.profile) &&
        this.checkExist(filter.categories, x.category) &&
        this.checkExist(filter.partners, x.partner)
      )
    })

    if (currentBenefits.length === 0) {
      currentBenefits = this.benefits
    }

    this.buildFilters(currentBenefits)
    currentBenefits = this.buildSort(currentBenefits, filter)
    this.totalItens = currentBenefits.length
    this.setState({
      filteredBenefits: this.buildPage(currentBenefits)
    })
  }

  buildSort = (list, filter) => {
    return list.sort((a, b) => {
      const nameA = a.name.toUpperCase()
      const nameB = b.name.toUpperCase()
      const priorityA = a.priority && a.priority === true
      const priorityB = b.priority && b.priority === true

      if (priorityA === priorityB) {
        if (filter.order.selected === 'ASCENDING') {
          if (nameA > nameB) {
            return 1
          } else if (nameA < nameB) {
            return -1
          }
        }
        if (filter.order.selected === 'DESCENDING') {
          if (nameA < nameB) {
            return 1
          } else if (nameA > nameB) {
            return -1
          }
        }
        if (filter.order.selected === 'HIGHERDISCOUNTS') {
          if (a.discount > b.discount) {
            return -1
          } else if (a.discount < b.discount) {
            return 1
          }
        }
      }
      return priorityA ? -1 : 1
    })
  }

  buildPage = (list) => {
    return list.slice(0, this.pageIndex * this.pageSize)
  }

  distinctArray = (array) => {
    var flags = {}
    var newArray = array.filter(function (entry) {
      if (flags[entry.link]) {
        return false
      }
      flags[entry.link] = true
      return true
    })
    return newArray
  }

  buildFilters = (listBenefits) => {
    let profiles = []
    let categories = []
    let partners = []
    if (listBenefits && listBenefits.length > 0) {
      listBenefits.map((item) => {
        if (profiles && profiles.find(x => x.name === item.profile)) {
          const idx = profiles.findIndex(x => x.name === item.profile)
          profiles[idx].quantity = profiles[idx].quantity + 1
        } else {
          profiles.push({ name: item.profile, quantity: 1 })
        }

        if (categories && categories.find(x => x.name === item.category)) {
          const idx = categories.findIndex(x => x.name === item.category)
          categories[idx].quantity = categories[idx].quantity + 1
        } else {
          categories.push({ name: item.category, quantity: 1 })
        }

        if (partners && partners.find(x => x.name === item.partner)) {
          const idx = partners.findIndex(x => x.name === item.partner)
          partners[idx].quantity = partners[idx].quantity + 1
        } else {
          partners.push({ name: item.partner, quantity: 1 })
        }
      })
      profiles = this.buildSort(profiles, { order: { selected: 'ASCENDING' } })
      categories = this.buildSort(categories, { order: { selected: 'ASCENDING' } })
      partners = this.buildSort(partners, { order: { selected: 'ASCENDING' } })
      this.setState({
        profiles: profiles,
        categories: categories,
        partners: partners
      })
    }
  }

  removeTags = (tag) => {
    let { filter } = this.state
    switch (tag.filterType) {
      case 'PROFILE': {
        filter.profiles = this.setFilterValue(
          filter.profiles,
          tag.valueFilter,
          'remove',
          tag.filterType
        )
        break
      }
      case 'CATEGORY': {
        filter.categories = this.setFilterValue(
          filter.categories,
          tag.valueFilter,
          'remove',
          tag.filterType
        )
        break
      }
      case 'PARTNER': {
        filter.partners = this.setFilterValue(
          filter.partners,
          tag.valueFilter,
          'remove',
          tag.filterType
        )
        break
      }
    }
    this.setState({
      filter: filter
    })
    this.filterBenefits()
    this.queryParameters()
  }

  removeAllTags = () => {
    let { filter } = this.state
    filter.profiles = []
    filter.categories = []
    filter.partners = []

    this.setState({ filter, tags: [] })
    this.filterBenefits()
    this.props.history.push({
      pathname: this.props.location.pathname
    })
  }

  setFilterValue = (sideBarFilter, valueFilter, action, filterType) => {
    sideBarFilter = sideBarFilter || []

    if (valueFilter === undefined) {
      return sideBarFilter
    }

    if (!Array.isArray(valueFilter)) {
      valueFilter = isNaN(valueFilter) ? valueFilter.split(',') : [valueFilter]
    }
    let tags = this.state.tags

    valueFilter.map(valueItem => {
      if (valueItem !== undefined && valueItem !== null) {
        switch (action) {
          case 'add': {
            sideBarFilter.push(String(valueItem))
            tags.push({ filterType, valueFilter })
            break
          }
          case 'remove': {
            sideBarFilter = sideBarFilter.filter(value => {
              return value !== String(valueItem)
            })
            tags = tags.filter(x => x.filterType !== String(filterType))
            sideBarFilter.forEach(e => {
              tags.push({ filterType, valueFilter: e })
            })
            break
          }
          default: {
            sideBarFilter = isNaN(valueItem)
              ? valueItem.length > 0
                ? String(valueItem)
                : null
              : valueItem
          }
        }
      }
    })
    this.setState({ tags })

    return sideBarFilter
  }

  loadItems = () => {
    this.pageIndex = this.pageIndex + 1
    this.filterBenefits()
  }

  get hasMoreItems () {
    return this.totalItens > (this.pageIndex * this.pageSize)
  }
}

BaseListing.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object
}

export default BaseListing



// WEBPACK FOOTER //
// ./src/features/Benefits/Listing/BaseListing.js